import React, { Fragment } from "react";
import PropTypes from "prop-types";

import { Typography } from '@telus-uds/components-web';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import { useLocaleContext } from '../../context/LocaleContext';
import { Button } from "../../design/css";

const DefectSummaryHeader = ({
    reportedOn,
    webForm,
    priority,
    status,
    assignee,
    setAssigneeModal,
    isAdmin
}) => {
    const locale = useLocaleContext();
    const {
        DEFECT_MANAGEMENT: { DEFECT_TABLE: { REPORTED_ON, WEBFORM, PRIORITY, STATUS, ASSIGNEE } = {} } = {}
    } = locale === 'en-US' ? EN : FR;

    const getButton = (onClick, label, isDisabled) => (
        <Button onClick={onClick} disabled={isDisabled}>
            {label}
        </Button>
    );

    // Typography's inline `style` color override is unreliable (known UDS gotcha) -
    // use a plain div to guarantee the SOF2-matching purple label color renders.
    const labelStyle = { color: '#4B286D', fontWeight: 700, fontSize: '16px', lineHeight: '24px' };

    return (
        <Fragment>
            <div style={{ paddingBottom: '16px', display: 'flex', flexDirection: 'column' }}>
                <div style={labelStyle}>{REPORTED_ON}:</div>
                <Typography>{reportedOn}</Typography>
            </div>
            <div style={{ paddingBottom: '16px', display: 'flex', flexDirection: 'column' }}>
                <div style={labelStyle}>{WEBFORM}:</div>
                <Typography>{webForm}</Typography>
            </div>
            <div style={{ paddingBottom: '16px', display: 'flex', flexDirection: 'column' }}>
                <div style={labelStyle}>{PRIORITY}:</div>
                <Typography>{priority} </Typography>
            </div>
            <div style={{ paddingBottom: '16px', display: 'flex', flexDirection: 'column' }}>
                <div style={labelStyle}>{STATUS}:</div>
                <Typography>{status} </Typography>
            </div>
            {isAdmin &&
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <div style={labelStyle}>{ASSIGNEE}:</div>
                    {getButton(
                        () => setAssigneeModal(true),
                        (assignee && assignee.length > 0 && assignee[0].label) ? `[ ${assignee[0].label.toString().toLowerCase()} ]` : '[ assign defect ]'
                    )}
                </div>
            }
        </Fragment>
    );
};

DefectSummaryHeader.prototype = {
    reportedOn: PropTypes.string.isRequired,
    webForm: PropTypes.string.isRequired,
    priority: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
};

export default DefectSummaryHeader;
